import * as OFMSUI from "react-bootstrap"; import "bootstrap/dist/css/bootstrap.min.css"; import { Field, useFormik, FormikProvider, ErrorMessage } from "formik"; import * as Yup from "yup"; import React, { useState } from "react"; import { Form } from "react-bootstrap"; import Swal from "sweetalert2/dist/sweetalert2.js";
import HousingService from "../../../Services/HousingService"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { generatePDF, LabelHeader, loginuser, ModuleHeaderTitle, NumberValidation } from "../../utils/commonFunctions";
import { store } from "../../../App"; import ShowAlert from "../../alert"; import { AiOutlineSearch } from "react-icons/ai"; import { MdOutlinePictureAsPdf } from "react-icons/md"; import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { Table } from "react-bootstrap"; import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { FaEdit } from "react-icons/fa";
import { ImCancelCircle } from "react-icons/im";

const HeadsOpeningBalance = () => {
    const history = useHistory();

    const [openingBalanceData, setOpeningBalance] = useState([]);
    const [originalRowValues, setOriginalRowValues] = useState({});
    const [distListt, setDistListtt] = useState([]);
    const [saveId, setSaveId] = useState("");



    const [search, setSearch] = useState("");

    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

    const [selectedList, setSelectedList] = useState([]);

    const [showTable, setShowTable] = useState(false);
    const [showSubHeadsTable, setShowSubHeadsTable] = useState(false);
    const [editingRow, setEditingRow] = useState(null);



    const validationSchema = Yup.object().shape({
        headtype: Yup.string().required("headtype is required"),
        district: Yup.string().required("district is required"),
    });

    const formik = useFormik({
        initialValues: {
            headtype: "",
            district: "",
            rows: [{
                credit: '',
                debit: '',
                checking: false,
            }]
        },
        validationSchema: validationSchema,
        onSubmit: () => {
            submitClickAction();
        }

    });

    const submitClickAction = () => {
        setSaveId(formik.values.district);
        setEditingRow(null);
        setSelectedCheckboxes([]); setSelectedList([]);
        store.dispatch({ type: "SHOW_SPINNER" });
        formik.setFieldValue("rows", formik.values.rows.map(row => ({ ...row, credit: "", debit: "", checking: false })));
        let params = { "headType": formik.values.headtype, "securityid": formik.values.district };
        HousingService.openeningBalanceHeadsData(params).then((res) => {
            if (res && res.data && res.data.length > 0) {
                setOpeningBalance(res.data);
                const newdata = { ...formik.values };
                newdata.rows = res.data.map((item) => ({
                    credit: item.credit,
                    debit: item.debit,
                    checking: false
                }));
                formik.setValues(newdata);
            }
            else {
                setOpeningBalance([])
            }
        }).catch((error) => {
            ShowAlert("Some Error Occured", "error");
        }).finally(() => {
            store.dispatch({ type: "HIDE_SPINNER" });
            setShowTable(true);
            setShowSubHeadsTable(false);
        });

    }




    const handleSearch = event => { setSearch(event.target.value) }

    const filteredData = search.length > 0 ? openingBalanceData?.filter((item) => {
        return (
            item && Object.keys(item).some((key) => {
                const value = item[key];
                return (
                    value !== null && value.toString().toLowerCase().includes(search.toLowerCase()));
            }));
    }) : openingBalanceData;

    const handleCheckboxChange = (event, detail, i) => {
        const selected = event.target.checked;
        setSelectedCheckboxes((prevSelectedCheckboxes) => {
            if (selected) {
                return [...prevSelectedCheckboxes, detail.headid];
            } else {
                return prevSelectedCheckboxes.filter((value) => value !== detail.headid);
            }
        });
        setSelectedList((prevList) => {
            if (selected) {
                return [
                    ...prevList,
                    {
                        headid: detail.headid,
                        securityid: saveId,
                        credit: parseFloat(formik.values.rows[i]?.credit),
                        debit: parseFloat(formik.values.rows[i]?.debit),
                    },
                ];
            } else {
                return prevList.filter((value) => value.headid !== detail.headid);
            }
        });
    };



    const submitList = () => {
        // console.log(selectedList);
        if (selectedList.length > 0) {
            Swal.fire({
                text: "Are You Sure Want to Submit?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.isConfirmed) {
                    store.dispatch({ type: "SHOW_SPINNER" });
                    let params = selectedList;
                    HousingService.insertopeneningBalanceHeadsData(params).then((res) => {
                        if (res.data.responseToken === "1") {
                            ShowAlert(res.data.responseMessage, "success").then(function (isConfirm) {
                                if (isConfirm.value) {
                                    // history.go(0);
                                    submitClickAction();
                                }
                            });
                        }
                        else {
                            ShowAlert(res.data.responseMessage, "error")
                        }
                    }).catch((error) => {
                        ShowAlert("Some error occcured", "error");
                    }).finally(() => {
                        store.dispatch({ type: "HIDE_SPINNER" });
                    });
                }
            });

        } else {
            ShowAlert("Please select atleast one Head ID", "warning");
        }
    };






    const HeadsOpeningBalanceBack = () => {
        setSearch("");
        if (showSubHeadsTable) {
            setShowSubHeadsTable(false)
            setShowTable(true);
        }
        else {
            history.goBack();
        }
    }

    const handleRowSubmit = (index) => {
        const updatedRow = formik.values.rows[index];
        const headId = openingBalanceData[index]?.headid;
        const securityid = openingBalanceData[index]?.security_id;
        const debit = Number(updatedRow.debit) || 0;
        const credit = Number(updatedRow.credit) || 0;

        if (debit > 0 && credit > 0) {
            ShowAlert(
                "Invalid Entry",
                "warning"
            );
            return;
        }

        Swal.fire({
            html: `
            <p>Are you sure you want to update?</p>
            <p><strong>Head ID:</strong> ${headId}</p>
            <p><strong>Debit Amount:</strong> ${debit}</p>
            <p><strong>Credit Amount:</strong> ${credit}</p>
        `,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Update",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {

                store.dispatch({ type: "SHOW_SPINNER" });

                let params = { headid: headId, securityid: securityid, debit: debit, credit: credit };
                HousingService.editHeadsDebitCreditAmount(params)
                    .then((res) => {
                        if (res.data.responseToken === "1") {
                            ShowAlert(res.data.responseMessage, "success")
                                .then(function (isConfirm) {
                                    if (isConfirm.value) {
                                        submitClickAction();
                                    }
                                });
                        } else {
                            ShowAlert(res.data.responseMessage, "error");
                        }
                    })
                    .catch(() => {
                        ShowAlert("Some error occurred", "error");
                    })
                    .finally(() => {
                        setEditingRow(null);
                        store.dispatch({ type: "HIDE_SPINNER" });
                    });
            }
        });
    };




    const handleCancelEdit = (index) => {
        const original = originalRowValues[index];

        if (original) {
            formik.setFieldValue(`rows[${index}].debit`, original.debit);
            formik.setFieldValue(`rows[${index}].credit`, original.credit);
        }

        setEditingRow(null);
    };

    React.useEffect(() => {
        HousingService.CGG_District().then((res) => {
            if (res.data) {
                let options = res.data.map((item, i) => { return (<option key={i} value={item.code}> {item.name} </option>); }); setDistListtt(options);
            }
        });
    }, [])



    return (
        <>
            <NavigationServicesHeader />
            <OFMSUI.Container fluid style={{ width: "90%" }}> <OFMSUI.Row> <ModuleHeaderTitle title="Heads Opening Balance as on 01-04-2022" /> <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" > <button className="btn btn-primary" style={{ textAlign: "right", float: "right", marginTop: "30px" }} type="button" onClick={() => HeadsOpeningBalanceBack()} > Back </button> </OFMSUI.Col> </OFMSUI.Row> </OFMSUI.Container>

            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                    <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
                        <OFMSUI.Row className="mb-3">
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" >
                                <LabelHeader title="District" />
                                <Field component="select" name="district" className={formik.touched.district && formik.errors.district ? "form-control is-invalid" : "form-control"} >
                                    <option value="">Select</option>
                                    {distListt}
                                </Field>
                                <ErrorMessage name="district" component={"div"} className="text-error" />
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" >
                                <LabelHeader title="Head type" />
                                <Field component="select" name="headtype" className={formik.touched.headtype && formik.errors.headtype ? "form-control is-invalid" : "form-control"} >
                                    <option value="">Select</option>
                                    <option value="liabilities">Liabilities</option>
                                    <option value="assets">Assets</option>
                                </Field>
                                <ErrorMessage name="headtype" component={"div"} className="text-error" />
                            </OFMSUI.Col>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className="mb-3"> <div className="d-grid mt-2"> <button type="submit" className="btn btn-success btn-sm mt-3"> Get Details </button> </div> </OFMSUI.Col>
                        </OFMSUI.Row>
                        {showTable && (<>
                            <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=' mb-3' > <div className='input-group'> <div className='input-group-prepend'> <div className='input-group-text group_txt11' id='btnGroupAddon' > <AiOutlineSearch /> </div> </div> <input type='text' id='#filterInput' placeholder='Search by Head ID' style={{ width: '25%' }} className='form-control input-lg' value={search} onChange={handleSearch} ></input> </div> </OFMSUI.Col>
                                <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=' mb-2 float-end' > <button type='button' className='btn btn-success btn-sm' style={{ float: 'right', color: '#fff', marginLeft: '3px' }} > <ReactHTMLTableToExcel id='my-table-xls-button' className='download-table-xls-button' table='my-table' filename='HeadsOpeningBalance' sheet='tablexls' buttonText='Excel' /> </button> <button className='btn btn-danger btn-sm' type='button' style={{ float: 'right', marginLeft: '3px' }} onClick={() => generatePDF("my-table", "Heads Opening Balance as on 01-04-2024", "HeadsOpeningBalance.pdf", 5)}> PDF <MdOutlinePictureAsPdf /> </button> </OFMSUI.Col>
                            </OFMSUI.Row>
                            <div style={{ overflow: "auto", height: "480px" }}>
                                <Table striped bordered hover id="my-table" style={{ width: "100%" }}>
                                    <thead className="fw-bold" style={{ top: "0px", position: "sticky" }}>
                                        <tr className="table_countshead">
                                            <th className="text-center">S.No.</th> <th>Head ID</th> <th>Head Name</th> <th>Debit</th> <th>Credit</th> <th style={{ textAlign: "center" }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData?.length === 0 || filteredData === undefined ? (
                                            <tr>
                                                <td colSpan={6} style={{ fontSize: "15px", textAlign: "center" }}> No details found </td>
                                            </tr>
                                        ) : (
                                            filteredData.map((detail, i) => {
                                                const originalIndex = openingBalanceData.findIndex(d => d.headid === detail.headid)
                                                return (

                                                    <tr key={originalIndex}>
                                                        <td className="text-center">{originalIndex + 1}</td>
                                                        <td>{detail.headid}</td>
                                                        <td>{(detail?.headname ?? "").toUpperCase()}</td>
                                                        <td>
                                                            <Field
                                                                type="text"
                                                                name={`rows[${originalIndex}].debit`}
                                                                className="form-control input-lg"
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`rows[${originalIndex}].debit`, e.target.value);
                                                                }}
                                                                onKeyPress={(e) => NumberValidation(e)}
                                                                maxLength={20}
                                                                readOnly={detail.status === "insert" ? false : detail.status === "Submitted" ? editingRow !== originalIndex : true}
                                                                onPaste={(e) => { e.preventDefault(); const text = e.clipboardData.getData("Text"); const numericText = text.replace(/[^0-9]/g, ""); formik.setFieldValue(e.target.name, numericText); }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Field
                                                                type="text"
                                                                name={`rows[${originalIndex}].credit`}
                                                                className="form-control input-lg"
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`rows[${originalIndex}].credit`, e.target.value);

                                                                }}
                                                                onKeyPress={(e) => NumberValidation(e)}
                                                                maxLength={20}
                                                                readOnly={detail.status === "insert" ? false : detail.status === "Submitted" ? editingRow !== originalIndex : true}
                                                                onPaste={(e) => { e.preventDefault(); const text = e.clipboardData.getData("Text"); const numericText = text.replace(/[^0-9]/g, ""); formik.setFieldValue(e.target.name, numericText); }}
                                                            />
                                                        </td>
                                                        <td style={{ textAlign: "center" }}>
                                                            {detail.status === "insert" ? (
                                                                <center>
                                                                    <input
                                                                        type="checkbox"
                                                                        name={`rows[${originalIndex}].checking`}
                                                                        value={detail.headid}
                                                                        onChange={(event) =>
                                                                            handleCheckboxChange(event, detail, originalIndex)
                                                                        }
                                                                        checked={selectedCheckboxes.includes(detail.headid)}
                                                                        disabled={
                                                                            !formik.values.rows[originalIndex]?.debit ||
                                                                            !formik.values.rows[originalIndex]?.credit ||
                                                                            (
                                                                                Number(formik.values.rows[originalIndex]?.debit) > 0 &&
                                                                                Number(formik.values.rows[originalIndex]?.credit) > 0
                                                                            )
                                                                        }
                                                                    />
                                                                </center>
                                                            ) : loginuser === "APSHCL" ? (
                                                                editingRow === originalIndex ? (
                                                                    <>
                                                                        <button type="button" className="btn btn-success btn-sm me-2" onClick={() => handleRowSubmit(originalIndex)} > Update </button>
                                                                        <button type="button" onClick={() => handleCancelEdit(originalIndex)} className="btn p-0" style={{ background: "transparent", border: "none" }} > <ImCancelCircle size={20} color="red" /> </button>
                                                                    </>
                                                                ) : (
                                                                    <button type="button" className="btn btn-sm" onClick={() => setEditingRow(originalIndex)} > <FaEdit style={{ fontSize: "20px", color: "orange" }} /> </button>
                                                                )
                                                            ) : (
                                                                <span style={{ color: "#00AB66", fontWeight: "bold" }}>✅</span>
                                                            )}
                                                        </td>

                                                    </tr>
                                                )
                                            })
                                        )}
                                    </tbody>
                                    <tfoot style={{ bottom: "0px", position: "sticky" }}> <tr className="table_countshead"> <td colSpan={3} style={{ textAlign: "right" }}> Total</td> <td>{filteredData.reduce((a, b) => a + (b.debit || 0), 0)}</td> <td>{filteredData.reduce((a, b) => a + (b.credit || 0), 0)}</td> <td></td> </tr> </tfoot>
                                </Table>
                            </div>
                            <div style={{ textAlign: "center", marginTop: "20px" }}> <button type="button" onClick={() => submitList()} className="btn btn-success sm"> Submit </button> </div>
                        </>)}
                    </OFMSUI.Container>
                </Form>
            </FormikProvider>




        </>
    )
}

export default HeadsOpeningBalance
